module.exports = __webpack_public_path__ + "media/images/new_landing/favicon/safari-pinned-tab-7027c38cf744920dbc971531a6ff3683.svg";